import React, { useEffect, useRef, useState } from "react";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";
import { ArrowDownMini, ArrowUpMini } from "../../assets/SvgIcons";

const chartData = [
  {
    title: "OverAll Market Index",
    stats: [
      {
        span: "1Y",
        index: {
          indexValue: "59,935",
          isFall: true,
          percentage: "4.8",
          value: "-3017 1Y",
        },
        data: [
          { date: "2023-01-01", rate: 100 },
          { date: "2023-02-01", rate: 102 },
          { date: "2023-03-01", rate: 104 },
          { date: "2023-04-01", rate: 103 },
          { date: "2023-05-01", rate: 105 },
          { date: "2023-06-01", rate: 107 },
          { date: "2023-07-01", rate: 106 },
          { date: "2023-08-01", rate: 108 },
          { date: "2023-09-01", rate: 110 },
          { date: "2023-10-01", rate: 112 },
          { date: "2023-11-01", rate: 111 },
          { date: "2023-12-01", rate: 113 },
        ],
      },
      {
        span: "5Y",
        index: {
          indexValue: "59,935",
          isFall: true,
          percentage: "4.8",
          value: "-3017 1Y",
        },
        data: [
          { date: "2023-01-01", rate: 100 },
          { date: "2023-02-01", rate: 102 },
          { date: "2023-03-01", rate: 104 },
          { date: "2023-04-01", rate: 103 },
          { date: "2023-11-01", rate: 111 },
          { date: "2023-12-01", rate: 113 },
        ],
      },
      {
        span: "10Y",
        index: {
          indexValue: "59,935",
          isFall: false,
          percentage: "4.8",
          value: "-3017 1Y",
        },
        data: [
          { date: "2023-01-01", rate: 100 },
          { date: "2023-06-01", rate: 107 },
          { date: "2023-07-01", rate: 106 },
          { date: "2023-08-01", rate: 108 },
          { date: "2023-09-01", rate: 110 },
          { date: "2023-10-01", rate: 112 },
          { date: "2023-11-01", rate: 111 },
          { date: "2023-12-01", rate: 113 },
        ],
      },
      {
        span: "MAX",
        index: {
          indexValue: "59,935",
          isFall: true,
          percentage: "4.8",
          value: "-3017 1Y",
        },
        data: [
          { date: "2023-01-01", rate: 100 },
          { date: "2023-02-01", rate: 102 },
          { date: "2023-03-01", rate: 104 },
          { date: "2023-04-01", rate: 103 },
          { date: "2023-05-01", rate: 105 },
        ],
      },
    ],
  },
  {
    title: "Rolex Market Index",
    stats: [
      {
        span: "1Y",
        index: {
          indexValue: "59,935",
          isFall: true,
          percentage: "4.8",
          value: "-3017 1Y",
        },
        data: [
          { date: "2023-01-01", rate: 100 },
          { date: "2023-02-01", rate: 102 },
          { date: "2023-03-01", rate: 104 },
          { date: "2023-04-01", rate: 103 },
          { date: "2023-05-01", rate: 105 },
          { date: "2023-06-01", rate: 107 },
          { date: "2023-07-01", rate: 106 },
          { date: "2023-08-01", rate: 108 },
          { date: "2023-09-01", rate: 110 },
          { date: "2023-10-01", rate: 112 },
          { date: "2023-11-01", rate: 111 },
          { date: "2023-12-01", rate: 113 },
        ],
      },
      {
        span: "5Y",
        index: {
          indexValue: "59,935",
          isFall: true,
          percentage: "4.8",
          value: "-3017 1Y",
        },
        data: [
          { date: "2023-01-01", rate: 100 },
          { date: "2023-02-01", rate: 102 },
          { date: "2023-03-01", rate: 104 },
          { date: "2023-04-01", rate: 103 },
          { date: "2023-11-01", rate: 111 },
          { date: "2023-12-01", rate: 113 },
        ],
      },
      {
        span: "10Y",
        index: {
          indexValue: "59,935",
          isFall: false,
          percentage: "4.8",
          value: "-3017 1Y",
        },
        data: [
          { date: "2023-01-01", rate: 100 },
          { date: "2023-06-01", rate: 107 },
          { date: "2023-07-01", rate: 106 },
          { date: "2023-08-01", rate: 108 },
          { date: "2023-09-01", rate: 110 },
          { date: "2023-10-01", rate: 112 },
          { date: "2023-11-01", rate: 111 },
          { date: "2023-12-01", rate: 113 },
        ],
      },
      {
        span: "MAX",
        index: {
          indexValue: "59,935",
          isFall: true,
          percentage: "4.8",
          value: "-3017 1Y",
        },
        data: [
          { date: "2023-01-01", rate: 100 },
          { date: "2023-02-01", rate: 102 },
          { date: "2023-03-01", rate: 104 },
          { date: "2023-04-01", rate: 103 },
          { date: "2023-05-01", rate: 105 },
        ],
      },
    ],
  },
  {
    title: "Patek Philippe Market Index",
    stats: [
      {
        span: "1Y",
        index: {
          indexValue: "59,935",
          isFall: true,
          percentage: "4.8",
          value: "-3017 1Y",
        },
        data: [
          { date: "2023-01-01", rate: 100 },
          { date: "2023-02-01", rate: 102 },
          { date: "2023-03-01", rate: 104 },
          { date: "2023-04-01", rate: 103 },
          { date: "2023-05-01", rate: 105 },
          { date: "2023-06-01", rate: 107 },
          { date: "2023-07-01", rate: 106 },
          { date: "2023-08-01", rate: 108 },
          { date: "2023-09-01", rate: 110 },
          { date: "2023-10-01", rate: 112 },
          { date: "2023-11-01", rate: 111 },
          { date: "2023-12-01", rate: 113 },
        ],
      },
      {
        span: "5Y",
        index: {
          indexValue: "59,935",
          isFall: true,
          percentage: "4.8",
          value: "-3017 1Y",
        },
        data: [
          { date: "2023-01-01", rate: 100 },
          { date: "2023-02-01", rate: 102 },
          { date: "2023-03-01", rate: 104 },
          { date: "2023-04-01", rate: 103 },
          { date: "2023-11-01", rate: 111 },
          { date: "2023-12-01", rate: 113 },
        ],
      },
      {
        span: "10Y",
        index: {
          indexValue: "59,935",
          isFall: false,
          percentage: "4.8",
          value: "-3017 1Y",
        },
        data: [
          { date: "2023-01-01", rate: 100 },
          { date: "2023-06-01", rate: 107 },
          { date: "2023-07-01", rate: 106 },
          { date: "2023-08-01", rate: 108 },
          { date: "2023-09-01", rate: 110 },
          { date: "2023-10-01", rate: 112 },
          { date: "2023-11-01", rate: 111 },
          { date: "2023-12-01", rate: 113 },
        ],
      },
      {
        span: "MAX",
        index: {
          indexValue: "59,935",
          isFall: true,
          percentage: "4.8",
          value: "-3017 1Y",
        },
        data: [
          { date: "2023-01-01", rate: 100 },
          { date: "2023-02-01", rate: 102 },
          { date: "2023-03-01", rate: 104 },
          { date: "2023-04-01", rate: 103 },
          { date: "2023-05-01", rate: 105 },
        ],
      },
    ],
  },
  {
    title: "Audemars Piguet  Market Index",
    stats: [
      {
        span: "1Y",
        index: {
          indexValue: "59,935",
          isFall: true,
          percentage: "4.8",
          value: "-3017 1Y",
        },
        data: [
          { date: "2023-01-01", rate: 100 },
          { date: "2023-02-01", rate: 102 },
          { date: "2023-03-01", rate: 104 },
          { date: "2023-04-01", rate: 103 },
          { date: "2023-05-01", rate: 105 },
          { date: "2023-06-01", rate: 107 },
          { date: "2023-07-01", rate: 106 },
          { date: "2023-08-01", rate: 108 },
          { date: "2023-09-01", rate: 110 },
          { date: "2023-10-01", rate: 112 },
          { date: "2023-11-01", rate: 111 },
          { date: "2023-12-01", rate: 113 },
        ],
      },
      {
        span: "5Y",
        index: {
          indexValue: "59,935",
          isFall: true,
          percentage: "4.8",
          value: "-3017 1Y",
        },
        data: [
          { date: "2023-01-01", rate: 100 },
          { date: "2023-02-01", rate: 102 },
          { date: "2023-03-01", rate: 104 },
          { date: "2023-04-01", rate: 103 },
          { date: "2023-11-01", rate: 111 },
          { date: "2023-12-01", rate: 113 },
        ],
      },
      {
        span: "10Y",
        index: {
          indexValue: "59,935",
          isFall: false,
          percentage: "4.8",
          value: "-3017 1Y",
        },
        data: [
          { date: "2023-01-01", rate: 100 },
          { date: "2023-06-01", rate: 107 },
          { date: "2023-07-01", rate: 106 },
          { date: "2023-08-01", rate: 108 },
          { date: "2023-09-01", rate: 110 },
          { date: "2023-10-01", rate: 112 },
          { date: "2023-11-01", rate: 111 },
          { date: "2023-12-01", rate: 113 },
        ],
      },
      {
        span: "MAX",
        index: {
          indexValue: "59,935",
          isFall: true,
          percentage: "4.8",
          value: "-3017 1Y",
        },
        data: [
          { date: "2023-01-01", rate: 100 },
          { date: "2023-02-01", rate: 102 },
          { date: "2023-03-01", rate: 104 },
          { date: "2023-04-01", rate: 103 },
          { date: "2023-05-01", rate: 105 },
        ],
      },
    ],
  },
];

const Statistics = () => {
  return (
    <div className=" w-full lg:p-4 md:p-4 sm:p-0">
      <h1 className="lg:text-4xl md:text-2xl sm:text-xl mb-8">Market Data</h1>
      <div>
        <div className="grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-6">
          {chartData?.map((charts, index) => {
            return <ShowCharts chartData={charts} key={index} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default Statistics;

const ShowCharts = ({ chartData }) => {
  const [statActiveInfo, setStatActiveIndex] = useState(chartData?.stats[0]);
  const [chartWidth, setChartWidth] = useState(320);
  const containerPadding = 14;
  const parentRef = useRef(null);

  useEffect(() => {
    // Get the width of the parent element
    const updateWidth = () => {
      if (parentRef.current) {
        setChartWidth(parentRef.current.getBoundingClientRect().width);
      }
    };

    // Update the width on mount
    updateWidth();

    // Update the width on window resize
    window.addEventListener("resize", updateWidth);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  return (
    <div
      ref={parentRef}
      style={{ padding: containerPadding }}
      className="rounded-lg border flex flex-col bg-white "
    >
      {/* HEADING ELEMENTS */}
      <div>
        <h3 className="text-[16px] ">{chartData?.title}</h3>
        {/* <div className="flex gap-2 items-center">
          <h1 className="text-[30px] font-bold">
            {statActiveInfo?.index?.indexValue}
          </h1>
          <div
            className={` border ${
              statActiveInfo?.index?.isFall
                ? "border-red-800"
                : "border-green-800"
            } rounded-lg p-1 flex items-center gap-1`}
            style={{
              backgroundColor: statActiveInfo?.index?.isFall
                ? "rgb(255,0,0,0.2)"
                : "rgb(0,255,0,0.2)",
            }}
          >
            <span
              className={
                statActiveInfo?.index?.isFall
                  ? "text-red-800"
                  : "text-green-800"
              }
            >
              {statActiveInfo?.index?.isFall ? ArrowDownMini : ArrowUpMini}
            </span>{" "}
            <p
              className={
                statActiveInfo?.index?.isFall
                  ? "text-red-800 text-[12px]"
                  : "text-green-800 text-[12px]"
              }
            >
              {statActiveInfo?.index?.percentage}%
            </p>
          </div>
          <p
            className={
              statActiveInfo?.index?.isFall
                ? "text-red-700 text-[12px]"
                : "text-green-700 text-[12px]"
            }
          >
            {statActiveInfo?.index?.value}
          </p>
        </div> */}
      </div>

      {/* BUTTONS / TIME SPAN CHANGING OPTIONS */}

      {/* <div className="mb-6 mt-2">
        {chartData?.stats?.map((stat, index) => {
          return (
            <button
              key={index}
              onClick={() => setStatActiveIndex(stat)}
              className={`px-2 py-1 rounded-lg mx-1 text-[13px] ${
                statActiveInfo?.span === stat?.span
                  ? "bg-secondary text-white"
                  : "bg-primary"
              }`}
            >
              {stat?.span}
            </button>
          );
        })}
      </div> */}

      {/* RECHART */}
      <div className="overflow-x-hidden rounded-lg">
        <LineChart
          width={chartWidth}
          height={280}
          data={statActiveInfo?.data}
          className="bg-white rounded-lg p-2 text-white text-[12px] ml-[-32px]"
        >
          <CartesianGrid strokeDasharray="2 2" />
          <XAxis dataKey="date" />
          <YAxis />
          <Tooltip />
          <Line type="monotone" dataKey="rate" stroke="#8884d8" />
        </LineChart>
      </div>
    </div>
  );
};
